import React, { useRef } from 'react';
import { Sparkle } from '../Ornaments';
import { useScrollVar } from '../../hooks/useScrollVar';

const toMobile = (points, crop) =>
  points
    .map((p) => ({ ...p, x: ((p.x / 100) * crop.srcW - crop.x) / crop.w * 100 }))
    .filter((p) => p.x > 2 && p.x < 98);

const Passage = ({ lines }) => lines.map((para) => (
  <p key={para}>
    {para.split('\n').map((line, i) => (
      <React.Fragment key={line}>{i > 0 && <br />}{line}</React.Fragment>
    ))}
  </p>
));

const Copy = ({ realm, onExplore, className = '' }) => (
  <div className={`rhero-copy ${className}`} data-testid="realm-hero-copy">
    <p className="rhero-realm hero-reveal" style={{ '--d': '500ms' }} data-testid="realm-hero-numeral">Realm {realm.numeral}</p>
    <h1 className="rhero-title hero-reveal" style={{ '--d': '650ms' }} data-testid="realm-hero-title">{realm.name}</h1>
    <p className="rhero-sub hero-reveal" style={{ '--d': '800ms' }}>{realm.subtitle}</p>
    <span className="rhero-star hero-reveal" style={{ '--d': '900ms' }} aria-hidden>✦</span>
    <div className="rhero-passage hero-reveal" style={{ '--d': '1000ms' }}>
      <Passage lines={realm.passage} />
    </div>
    <button type="button" className="rhero-explore hero-reveal" style={{ '--d': '1200ms' }} onClick={onExplore} data-testid="realm-explore-btn">
      Explore the Collection
    </button>
  </div>
);

export const RealmHero = ({ realm, onExplore }) => {
  const ref = useRef(null);
  useScrollVar(ref);

  return (
    <section ref={ref} className="rhero" data-testid="realm-hero">
      <div className="rhero-ground" aria-hidden>
        <div className="rhero-sky" style={{ backgroundImage: `url('${realm.sky}')` }} />
        <div className="hero-stars hero-stars--a rhero-motes" />
        <div className="rhero-shafts"><span /><span /><span /></div>
      </div>

      <div className="rhero-ext-group" aria-hidden>
        <img src={realm.extLeft} alt="" className="rhero-ext rhero-ext--left" draggable="false" />
        <img src={realm.extRight} alt="" className="rhero-ext rhero-ext--right" draggable="false" />
      </div>

      <div className="rhero-plate" data-testid="realm-plate">
        <img src={realm.scene} alt={realm.sceneAlt || `${realm.name} — Ikarus before the drowned cathedral`} className="rhero-img" draggable="false" />
        <img src={realm.gold} alt="" className="hero-gold hero-gold--halo" draggable="false" aria-hidden />
        <img src={realm.gold} alt="" className="hero-gold hero-gold--base" draggable="false" aria-hidden />
        <img src={realm.gold} alt="" className="hero-gold hero-gold--glint" draggable="false" aria-hidden />
        {realm.twinkles.map((t) => <Sparkle key={`${t.x}-${t.y}`} {...t} className="rhero-twinkle" />)}

        <div className="rhero-position hero-reveal" style={{ '--d': '1300ms' }} aria-hidden>
          <span className="rhero-position-num">{realm.position}</span>
          <span className="rhero-position-dot" /><span className="rhero-position-dot" /><span className="rhero-position-dot" />
          <span className="rhero-position-line" />
        </div>

        <Copy realm={realm} onExplore={onExplore} className="rhero-copy--desktop" />
      </div>

      <div className="rhero-mobile" style={{ backgroundImage: `url('${realm.water}')` }}>
        <Copy realm={realm} onExplore={onExplore} className="rhero-copy--mobile" />
        <div className="rhero-mobile-plate">
          <img src={realm.sceneMobile} alt={realm.sceneAlt || `${realm.name} — Ikarus before the drowned cathedral`} className="rhero-img-m" draggable="false" />
          <img src={realm.goldMobile} alt="" className="hero-gold hero-gold--halo" draggable="false" aria-hidden />
          <img src={realm.goldMobile} alt="" className="hero-gold hero-gold--base" draggable="false" aria-hidden />
          {toMobile(realm.twinkles, realm.mobileCrop).map((t) => <Sparkle key={`m-${t.x}-${t.y}`} {...t} className="rhero-twinkle" />)}
        </div>
      </div>
    </section>
  );
};
